import { VatSupportedLineModelType } from '@teinor/erp/types/company/accounting/vatSupported/vatSupportedLine'
import HeaderVatSupportedFinished from './HeaderVatSupportedFinished'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ColumnITLayoutTableSchema } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { VatLayoutStepProps } from '../../../../../../../../specificComponents/inputTableLayouts/vat/VatLayout/types'
import VatLayout from '../../../../../../../../specificComponents/inputTableLayouts/vat/VatLayout'
import useBuyInvoiceHeaderURLs from '../../../../../../../../utils/hooks/buys/orders/useBuyInvoiceHeaderURLs'
import { VatSupportedStatusInversed } from '@teinor/erp/types/company/accounting/vatSupported'

interface VatSupportedFinishedStepProps extends VatLayoutStepProps { }

const VatSupportedFinishedStep: React.FC<VatSupportedFinishedStepProps> = ({ inputTableURLs, completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, userPermissions }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useBuyInvoiceHeaderURLs()
    const columns: ColumnITLayoutTableSchema<VatSupportedLineModelType> = [
        {
            id: 'rowPriceWithoutTax',
            dataKey: 'rowPriceWithoutTax',
            simpleLabel: t('totalWithoutVat', 'Base imponible'),
            label: () => <div className='text-right mr-10 w-full'>{t('totalWithoutVat', 'Base imponible')}</div>,
            component: 'ITDisplayPrice',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'taxUsed',
            dataKey: 'taxUsed',
            simpleLabel: t('taxUsed', 'Impuesto usado'),
            label: () => <div className='text-right mr-10 w-full'>{t('taxUsed', 'Impuesto usado')}</div>,
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'vatMoney',
            dataKey: 'vatMoney',
            label: ()=><div className='text-right mr-10 w-full'>{t('vatMoney', 'Impuestos a pagar')}</div>,
            simpleLabel: t('vatMoney', 'Impuestos a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        },
        {
            id: 'taxUsed2',
            dataKey: 'taxUsed2',
            simpleLabel: t('tax2', 'Segundo impuesto'),
            label: () => <div className='text-right mr-10 w-full'>{t('tax2', 'Segundo impuesto')}</div>,
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch'
        },
        {
            id: 'vatMoney2',
            dataKey: 'vatMoney2',
            label: () => <div className='text-right mr-10 w-full'>{t('vatMoney2', 'Impuestos 2 a pagar')}</div>,
            simpleLabel: t('vatMoney2', 'Impuestos 2 a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        },
        {
            id: 'retentionUsed',
            dataKey: 'retentionUsed',
            simpleLabel: t('retention', 'Retención'),
            label: () => <div className='text-right mr-10 w-full'>{t('retention', 'Retención')}</div>,
            component: 'ITDisplayPercent',
            minWidth: 125,
            typeOnChange: 'onChangeTotalsFetch',
            hideColumnByDefault: true
        },
        {
            id: 'retentionMoney',
            dataKey: 'retentionMoney',
            label: () => <div className='text-right mr-10 w-full'>{t('retentionMoney', 'Retención a pagar')}</div>,
            simpleLabel: t('retentionMoney', 'Retención a pagar'),
            component: 'ITDisplayPrice',
            minWidth: 125,
            hideColumnByDefault: true
        },
        {
            id: 'dua',
            dataKey: 'dua',
            label: () => <div className='text-right mr-10 w-full'>{t('dua', 'DUA')}</div>,
            component: 'ITRectangularInput',
            readOnlyFnc: () => true,
            hideColumnByDefault: true
        },
        {
            id: 'rowPriceWithTax',
            dataKey: 'rowPriceWithTax',
            label: () => <div className='text-right mr-10 w-full'>{t('priceTotal', 'Precio Total')}</div>,
            simpleLabel: t('priceTotal', 'Precio Total'),
            component: 'ITDisplayPrice',
            minWidth: 125,
        }
    ]
    return (
        <VatLayout modelId='VatSupportedId' name='vatSupportedFinishedStep' translations={{ headerTitle: t('vatSupported', 'IVA Soportado'), tableTitle: t('vats', 'Impuestos') }} InputTableHeaderChildren={HeaderVatSupportedFinished} {...{ columns, inputTableURLs, orderHeaderURLs, completeData, setCompleteData, getCompleteData, setTableConfiguration, tableConfiguration, userPermissions, title: t('vatSupported', 'IVA Soportado'), orderStatusDict: VatSupportedStatusInversed}}>
        </VatLayout>
    )
}


export default VatSupportedFinishedStep